import React from 'react';
import { Skeleton } from '../../ui/skeleton';
import { Card, CardContent } from '../../ui/card';
// import { CardHeader } from '../../ui/card'; // Unused
// import { ScrollArea } from '../../ui/scroll-area'; // Unused

const ChatLoadingSkeleton = ({ 
  showSidebar = true,
  messages = 8,
  className = ""
}) => {
  return (
    <div className={`flex h-full ${className}`}>
      {/* Sidebar - Chat List */}
      {showSidebar && (
        <div className="w-80 border-r bg-slate-50">
          {/* Header */}
          <div className="p-4 border-b">
            <Skeleton className="h-10 w-full" />
          </div>
          
          {/* Status Selector */}
          <div className="p-4">
            <Skeleton className="h-10 w-full" />
          </div>
          
          {/* Chat List */}
          <div className="space-y-2 p-2">
            {[...Array(5)].map((_, index) => (
              <div key={index} className="p-3 rounded-lg">
                <div className="flex items-start gap-3">
                  <Skeleton className="h-10 w-10 rounded-full" />
                  <div className="flex-1 space-y-2">
                    <div className="flex items-center justify-between">
                      <Skeleton className="h-4 w-32" />
                      <Skeleton className="h-3 w-16" />
                    </div>
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-3/4" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Main Chat Area */}
      <div className="flex-1 flex flex-col">
        {/* Chat Header */}
        <div className="p-4 border-b bg-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full" />
              <div className="space-y-1">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
            <div className="flex gap-2">
              <Skeleton className="h-8 w-8" />
              <Skeleton className="h-8 w-8" />
            </div>
          </div>
        </div>
        
        {/* Messages Area */}
        <div className="flex-1 p-4 space-y-4 overflow-y-auto">
          {[...Array(messages)].map((_, index) => (
            <div key={index} className={`flex ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
              <div className={`max-w-md ${index % 2 === 0 ? 'order-2' : 'order-1'}`}>
                <Card className={`${index % 2 === 0 ? 'bg-slate-100' : 'bg-blue-50'} border-0`}>
                  <CardContent className="p-3">
                    <div className="space-y-1">
                      <Skeleton className="h-4 w-full" />
                      <Skeleton className="h-4 w-3/4" />
                      {index % 3 === 0 && <Skeleton className="h-4 w-1/2" />}
                    </div>
                    <Skeleton className="h-3 w-16 mt-2" />
                  </CardContent>
                </Card>
              </div>
              {index % 2 === 0 && (
                <Skeleton className="h-8 w-8 rounded-full order-1 mr-2" />
              )}
            </div>
          ))}
        </div>
        
        {/* Message Input Area */}
        <div className="p-4 border-t bg-white">
          <div className="flex gap-2">
            <Skeleton className="h-10 flex-1" />
            <Skeleton className="h-10 w-10" />
            <Skeleton className="h-10 w-10" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLoadingSkeleton;